import Relay from 'react-relay';

export interface DeleteTestInvocationMutationProps {
    testInvocation: {
        id: string;
        realId?: string;
    };
}

export default class DeleteTestInvocationMutation extends Relay.Mutation<DeleteTestInvocationMutationProps, any> {
    private mutationProps: DeleteTestInvocationMutationProps;

    constructor(props: DeleteTestInvocationMutationProps) {
        super(props as any);
        this.mutationProps = props;
    }

    getMutation() {
        return Relay.QL`mutation {deleteTestInvocation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on DeleteTestInvocationPayload {
                deletedTestInvocationId
                success
                error
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            testInvocationId: this.mutationProps.testInvocation.realId || this.mutationProps.testInvocation.id,
        };
    }

    getOptimisticResponse() {
        return {
            deletedTestInvocationId: this.mutationProps.testInvocation.realId || this.mutationProps.testInvocation.id,
            success: true,
        };
    }
}
